import Config from 'config/settings';

/**
 * Resize-cached viewport/device singleton (verbatim port of debugbase
 * SystemHelper). THE single viewport lookup: the former
 * window.cachedInnerWidth/cachedInnerHeight globals were consolidated into
 * device.innerWidth/device.innerHeight — do not reintroduce parallel caches.
 *
 * The dimension/orientation values are snapshots taken at the last resize()
 * call, NOT live window reads — the app kernel calls device.resize() FIRST in
 * its resize handler (App._onResize, before any controller/module fan-out),
 * so readers always see the cached values from the last resize event. An
 * initial snapshot is taken at module load (the class took it in its
 * constructor), which covers all pre-first-resize reads at boot.
 *
 * `cordsFromTouch` is a mutable flag set by MouseController to record whether
 * the last mouse coordinates came from a touch event.
 *
 * The browser/OS flags (isIOS/isAndroid/isSafari/isMobile) are also plain
 * stored values: PreloadView runs the UA detection in setupOpeningMessages()
 * and writes them here — device does no detection of its own, and the flags
 * stay false until that runs (identical to the old undefined window props).
 */
let innerWidth = 0;
let innerHeight = 0;
let isPortraitDevice = false;

export const device = {
	cordsFromTouch: false,

	//Written by PreloadView.setupOpeningMessages(); read by PixiController's
	//FPS watchdog (and analytics events):
	isIOS: false,
	isAndroid: false,
	isSafari: false,
	isMobile: false,

	get innerWidth(): number {
		return innerWidth;
	},

	get innerHeight(): number {
		return innerHeight;
	},

	get isPortraitDevice(): boolean {
		return isPortraitDevice;
	},

	//Computed from the resize-cached width (not precomputed in resize()) so the
	//module-init resize() below touches no imports — settings.ts imports this
	//module (getCurrentMobileSwitch), and keeping evaluation dependency-free
	//makes the device <-> settings import cycle safe in both load orders.
	//Config.mobileBreakpoint is a constant, so values are identical to the old
	//per-resize snapshot at every read:
	get isSmallDevice(): boolean {
		return innerWidth < Config.mobileBreakpoint;
	},

	resize(): void {
		innerWidth = window.innerWidth;
		innerHeight = window.innerHeight;
		isPortraitDevice = window.innerWidth < window.innerHeight;
	}
};

device.resize();
